import { Component } from '@angular/core'
import { ToggleThemeService } from '@corporate-tailwind/widget';
import { TranslateModule } from '@ngx-translate/core'

@Component({
    selector: 'app-page-500',
    imports: [TranslateModule],
    templateUrl: './page-500.component.html',
    styleUrl: './page-500.component.scss'
})
export class Page500Component {
constructor(
        public _toggleThemeService: ToggleThemeService
    ) {}

    ngOnInit(): void {
        // Initialize theme and direction on component load
        this._toggleThemeService.initializeTheme();
    }

    // Toggle theme between light and dark
    toggleTheme() {
        this._toggleThemeService.toggleTheme();
    }

    // Toggle direction between LTR and RTL
    toggleDirection() {
        this._toggleThemeService.toggleDirection();
    }
}